// components/Navigation.js
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, Sun, Moon } from 'lucide-react';
import { useTheme } from '../contexts/ThemeContext';

const Navigation = () => {
  const { isDarkMode, toggleDarkMode } = useTheme();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <nav className="fixed top-0 left-0 right-0 bg-white/80 dark:bg-neutral-800/80 backdrop-blur-md shadow-lg z-50 transition-colors duration-500">
      <div className="max-w-6xl mx-auto px-4 py-4 flex justify-between items-center">
        <Link to="/" className="text-2xl font-bold tracking-tight dark:text-white">EL Ceballos</Link>
        
        <div className="flex items-center space-x-6">
          {/* Dark Mode Toggle */}
          <button 
            onClick={toggleDarkMode}
            className="p-2 rounded-lg hover:bg-neutral-200/50 dark:hover:bg-neutral-700/50 transition-colors duration-200"
            aria-label="Toggle dark mode"
          >
            {isDarkMode ? <Sun size={20} /> : <Moon size={20} />}
          </button>

          {/* Mobile Menu Toggle */}
          <div className="md:hidden">
            <button 
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="text-neutral-800 dark:text-white hover:text-neutral-600 dark:hover:text-neutral-300"
            >
              {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex space-x-6">
            <Link to="/about" className="hover:text-neutral-600 dark:text-white dark:hover:text-neutral-300">
              About
            </Link>
            
            {/* Work Dropdown */}
            {/* <div className="relative">
              <button 
                onClick={() => setWorkDropdownOpen(!workDropdownOpen)}
                onBlur={() => setTimeout(() => setWorkDropdownOpen(false), 200)}
                className="flex items-center hover:text-neutral-600 dark:text-white dark:hover:text-neutral-300"
              >
                Work
                <ChevronDown size={16} className={`ml-1 transform transition-transform duration-200 ${workDropdownOpen ? 'rotate-180' : ''}`} />
              </button>
              
              {workDropdownOpen && (
                <div className="absolute top-full left-0 mt-2 w-32 bg-white dark:bg-neutral-800 rounded-lg shadow-lg overflow-hidden">
                  <Link 
                    to="/gallery/2d"
                    className="block px-4 py-2 hover:bg-neutral-100 dark:hover:bg-neutral-700 dark:text-white"
                  >
                    2D
                  </Link>
                  <Link 
                    to="/gallery/video"
                    className="block px-4 py-2 hover:bg-neutral-100 dark:hover:bg-neutral-700 dark:text-white"
                  >
                    Video
                  </Link>
                  <Link 
                    to="/gallery/3d"
                    className="block px-4 py-2 hover:bg-neutral-100 dark:hover:bg-neutral-700 dark:text-white"
                  >
                    3D
                  </Link>
                </div>
              )}
            </div> */}

            <Link to="/contact" className="hover:text-neutral-600 dark:text-white dark:hover:text-neutral-300">
              Contact
            </Link>
          </div>
        </div>
      </div>

      {/* Mobile Menu Dropdown */}
      {mobileMenuOpen && (
        <div className="md:hidden bg-white/90 dark:bg-neutral-800/90 backdrop-blur-md absolute top-full left-0 right-0 shadow-lg">
          <div className="flex flex-col p-4 space-y-2">
            <Link to="/about" 
              className="py-2 border-b dark:border-neutral-700 text-left dark:text-white"
              onClick={() => setMobileMenuOpen(false)}>About</Link>
            
            {/* Mobile Work Menu */}
            {/* <div className="py-2 border-b dark:border-neutral-700">
              <div className="text-left dark:text-white mb-2">Work</div>
              <div className="pl-4 space-y-2">
                <Link 
                  to="/gallery/2d"
                  className="block text-neutral-600 dark:text-neutral-300 hover:text-neutral-900 dark:hover:text-white"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  2D
                </Link>
                <Link 
                  to="/gallery/video"
                  className="block text-neutral-600 dark:text-neutral-300 hover:text-neutral-900 dark:hover:text-white"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  Video
                </Link>
                <Link 
                  to="/gallery/3d"
                  className="block text-neutral-600 dark:text-neutral-300 hover:text-neutral-900 dark:hover:text-white"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  3D
                </Link>
              </div>
            </div> */}

            <Link to="/contact" 
              className="py-2 text-left dark:text-white"
              onClick={() => setMobileMenuOpen(false)}>Contact</Link>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navigation;